export default "__VITE_ASSET__4e73859b__"